
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'action';
  isLoading?: boolean;
  icon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  isLoading, 
  icon, 
  className = '', 
  ...props 
}) => {
  const baseStyles = "flex items-center justify-center gap-3 px-8 py-3 rounded-2xl font-bold transition-all duration-300 disabled:opacity-40 disabled:cursor-not-allowed active:scale-[0.96] text-sm";
  
  const variants = {
    primary: "bg-indigo-600 hover:bg-indigo-500 text-white shadow-xl shadow-indigo-600/10",
    secondary: "bg-transparent hover:bg-white/5 text-slate-200 border border-white/10",
    danger: "bg-rose-600 hover:bg-rose-500 text-white",
    ghost: "bg-transparent hover:bg-white/5 text-slate-500 hover:text-white",
    action: "bg-white hover:bg-slate-200 text-black shadow-[0_10px_30px_rgba(255,255,255,0.15)]"
  };

  // Spinner color should be black for action variant (white button)
  const spinnerColor = variant === 'action' ? 'text-black' : 'text-current';

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      disabled={isLoading || props.disabled}
      {...props}
    >
      {isLoading ? (
        <svg className={`animate-spin h-5 w-5 ${spinnerColor}`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        icon
      )}
      {children}
    </button>
  );
};

export default Button;
